/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Merge_With_LabelInputs */

const en_speaker_manager_merge_with_label = /** @type {(inputs: Speaker_Manager_Merge_With_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge With Speaker:`)
};

const fr_speaker_manager_merge_with_label = /** @type {(inputs: Speaker_Manager_Merge_With_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner avec le locuteur :`)
};

const de_speaker_manager_merge_with_label = /** @type {(inputs: Speaker_Manager_Merge_With_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Sprecher zusammenführen:`)
};

const it_speaker_manager_merge_with_label = /** @type {(inputs: Speaker_Manager_Merge_With_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci con l'oratore:`)
};

const ru_speaker_manager_merge_with_label = /** @type {(inputs: Speaker_Manager_Merge_With_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совместить со спикером:`)
};

const es_speaker_manager_merge_with_label = /** @type {(inputs: Speaker_Manager_Merge_With_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionarse con el orador:`)
};

const zh_cn2_speaker_manager_merge_with_label = /** @type {(inputs: Speaker_Manager_Merge_With_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与演讲者合并：`)
};

const ja_speaker_manager_merge_with_label = /** @type {(inputs: Speaker_Manager_Merge_With_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーと結合:`)
};

const hi_speaker_manager_merge_with_label = /** @type {(inputs: Speaker_Manager_Merge_With_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर के साथ मर्ज करें:`)
};

const pt_pt2_speaker_manager_merge_with_label = /** @type {(inputs: Speaker_Manager_Merge_With_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unir com o orador:`)
};

/**
* | output |
* | --- |
* | "Merge With Speaker:" |
*
* @param {Speaker_Manager_Merge_With_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_with_label = /** @type {((inputs?: Speaker_Manager_Merge_With_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_With_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_merge_with_label(inputs)
	if (locale === "de") return de_speaker_manager_merge_with_label(inputs)
	if (locale === "it") return it_speaker_manager_merge_with_label(inputs)
	if (locale === "ru") return ru_speaker_manager_merge_with_label(inputs)
	if (locale === "es") return es_speaker_manager_merge_with_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_merge_with_label(inputs)
	if (locale === "ja") return ja_speaker_manager_merge_with_label(inputs)
	if (locale === "hi") return hi_speaker_manager_merge_with_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_merge_with_label(inputs)
	return en_speaker_manager_merge_with_label(inputs)
});